<template>
  <v-card
    class="mx-auto pt-4"
    max-width="100%"
    outlined
  >
    <v-list-item three-line class="wrapper header-title">
      <v-list-item-content>
        <v-list-item-title class="headline mb-1" id="title">{{ name }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-card-actions class="card-actions">
      <v-container fluid>

        <v-layout wrap align-center hidden-sm-and-down>  
            <div class="wrapper">
              <v-flex md5 lg8>
                <v-chip v-if="tags[0].title === 'All'" disabled>
                  {{tags[0].title}}
                </v-chip>
                <v-chip-group v-else v-model="chips" multiple active-class="active-chip">
                  <v-chip 
                    v-for="(tag, index) in tags" :key="index"
                    id="chip">{{tag.title}}</v-chip>
                </v-chip-group>
              </v-flex>

              <v-flex md5 lg5 text-right>
                <v-text-field
                  hide-details
                  append-icon="search"
                  single-line
                  placeholder="Search..."
                  flat
                  solo
                  rounded
                  v-model="search"
                  class="search-bar-desktop"
                  @keyup="$emit('update:inputData', search);"
                ></v-text-field>
              </v-flex>

              <v-flex md2 lg2 text-right>
                <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    text
                    v-on="on"
                    class="sorting text-none"
                    :ripple="false"
                  >
                  {{sortingType}}
                    <v-icon right>fas fa-caret-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in items"
                    :key="index"
                    @click="onSort(item.title)"
                  >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              </v-flex>
            </div>
          </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import TokenService from "../../../services/storage.service";

export default {
  data() {
    return {
      search: "",
      chips: [],
      sortingType: ""
    };
  },
  props: ["name", "items", "inputData", "tags"],
  watch: {
    chips() {
      this.$emit("update:filtering", this.chips);
    }
  },
  methods: {
    onSort(sort) {
      if (this.name === "Public templates")
        TokenService.saveToken("templatesSortingType", sort);
      else if (this.name === "My templates")
        TokenService.saveToken("privateTemplatesSortingType", sort);
      else TokenService.saveToken("environmentsSortingType", sort);
      this.sortingType = sort;
      this.$emit("update:sorting", sort);
    }
  },
  created() {
    if (this.name === "Public templates")
      this.sortingType = TokenService.getToken("templatesSortingType");
    else if (this.name === "My templates")
      this.sortingType = TokenService.getToken("privateTemplatesSortingType");
    else this.sortingType = TokenService.getToken("environmentsSortingType");

    if (!this.sortingType) this.sortingType = "Newest top";
    this.$emit("update:sorting", this.sortingType);
  }
};
</script>

<style scoped>
.v-btn {
  padding: 0px !important;
}

#chip {
  background-color: #eeeeee;
  color: black;
}

.sorting {
  margin-top: 0.5vh;
  margin-left: 0.8vw;
  width: 13vw;
  /* font: 16px/19px "Montserrat" !important; */
  font-size: 1em !important;
  background-color: white !important;
  letter-spacing: 0;
}

.active-chip {
  background-color: #d0398b !important;
  color: white !important;
}

#chip:focus::before {
  opacity: 0 !important;
}
</style>
